import { useEffect, useState } from "react";
import styles from "./TextInput.module.css";

const TextInput = ({
  label = "",
  name,
  setSpecificState,
  initialValue,
  type = "text",
  isError,
  hasTitle = true,
  reset = false,
  isInFirstInput = false,
  isDisabled = false,
  maxLength = 150,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    if (event.target.value.length > maxLength) {
      return;
    }
    setInputValue(event.target.value);
    sessionStorage.setItem(name, event.target.value);
    setSpecificState(event.target.value);
  };

  useEffect(() => {
    const savedValue = sessionStorage.getItem(name);
    if (savedValue) {
      setInputValue(savedValue);
      setSpecificState(savedValue);
    }
  }, [name, setSpecificState]);

  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
      setSpecificState(initialValue);
      sessionStorage.setItem(name, initialValue);
    } else {
      const savedValue = sessionStorage.getItem(name);
      if (savedValue) {
        setInputValue(savedValue);
        setSpecificState(savedValue);
      }
    }
  }, [initialValue, name, setSpecificState]);

  useEffect(() => {
    sessionStorage.setItem(name, inputValue);
  }, [inputValue, name]);

  useEffect(() => {
    if (reset) {
      setInputValue("");
      setSpecificState("");
    }
  }, [reset]);

  return (
    <div
      className={`${styles.textInput} ${
        isError ? styles.placeholderError : ""
      } `}
    >
      {hasTitle && <label>{label}</label>}
      <input
        name={name}
        value={inputValue}
        className={`${isError ? styles.error : ""}${
          isInFirstInput ? styles.firstInput : ""
        }`}
        onChange={handleInputChange}
        placeholder={isError ? "Ovo polje je obavezno" : "prazno..."}
        type={type}
        disabled={isDisabled}
      ></input>
    </div>
  );
};

export default TextInput;
